// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tourText[data-v-26aff21c]{line-height:50%;white-space:nowrap}.md-card[data-v-26aff21c]{width:150px;margin:4px;display:inline-block;vertical-align:top;background:rgba(48,47,47,.767);border-radius:5px}.infoBox[data-v-26aff21c],.md-card[data-v-26aff21c],.md-card-header[data-v-26aff21c],.md-titel[data-v-26aff21c]{color:#fff}.infoBox[data-v-26aff21c]{width:150px;height:60px;border-radius:5px;padding:10px}", ""]);
// Exports
module.exports = exports;
